import httpClient from '@/_shared/http-client';
import { objectHelper, httpHelper } from "@/_shared/utils";

const CUSTOM_SLUG = '/achievements';
const GENERATED_SLUG = '/records/achievements';
const USER_SLUG = '/records/user_achievements';

const getForUser = async(onlyLastItems = true) => {
  const LAST_ITEMS_COUNT = 5;
  const url = new URL(USER_SLUG, process.env.BACKEND_URL);
  url.searchParams.set('filter', `user_id,eq,${1}`);
  url.searchParams.set('join', 'achievements');
  if (onlyLastItems) {
    url.searchParams.set('size', LAST_ITEMS_COUNT);
  }
  url.searchParams.set('order', 'date_of_receiving,desc');
  const response = await httpClient.get(url);
  return response;
};

const getAll = async() => {
  const url = new URL(GENERATED_SLUG, process.env.BACKEND_URL);
  url.searchParams.set('order', 'updated_at,desc');
  const response = await httpClient.get(url);
  return response;
};

const handle = (httpMethod = 'post') => async (form) => {
  form = objectHelper.createCopy(form);
  form.users = form.users.map(({ id }) => id);
  form = httpHelper.addDateField(form, httpMethod);
  const url = `${process.env.BACKEND_URL}${CUSTOM_SLUG}`;
  const response = await httpClient[httpMethod](url, form).catch(({ response }) => {
    throw new Error(response.data.message)
  });
  return response;
};

const deleteAchievement = async(form) => {
  const url = new URL(CUSTOM_SLUG, process.env.BACKEND_URL);
  url.searchParams.set('id', form.id);
  const response = await httpClient.delete(url).catch(({ response }) => {
    throw new Error(response.data.message);
  });
  return response;
};

const get = async(id) => {
  const url = new URL(CUSTOM_SLUG, process.env.BACKEND_URL);
  url.searchParams.set('id', id);
  let results = {};
  await httpClient.get(url)
    .then(({ data }) => {
      const { record } = data;
      results = record;
    })
    .catch((error) => {
      throw new Error(error.message);
    });
  return results;
};

export const achievementsService = {
  add: handle('post'),
  edit: handle('patch'),
  delete: deleteAchievement,
  getForUser,
  getAll,
  get,
};



// WEBPACK FOOTER //
// ./src/user/api-services/achievementsService.js